/**
 * src/app/marketplace/components/MarketplaceDisconnectControl.js
 * ---------------------------------------------------------------------------
 * This displays disconnect button for disconnecting QuickBooks.
 *
 * Renders nothing without a marketplace user session, so it is safe to place on any page.
 * ---------------------------------------------------------------------------
 */

import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { disconnect } from '../hooks/marketplaceSessionStore';
import '../marketplace.css';

export default function MarketplaceDisconnectControl({ provider, session }) {
	const history = useHistory();

	// 'idle' -> 'confirming' -> 'pending' -> 'error'
	const [phase, setPhase] = useState('idle');
	const [error, setError] = useState('');

	if (!session.signedIn) return null;

	async function handleDisconnect() {
		setPhase('pending');
		setError('');

		try {
			await disconnect(provider.disconnectPath);

			history.push(`/marketplace/${provider.key}/connect`);
		} catch (err) {
			setError(err.response?.data?.error || `Something went wrong disconnecting ${provider.label}. Please try again.`);
			setPhase('error');
		}
	}

	if (!session.connected) {
		return (
			<p className="mp-fineprint">
				<a className="mp-link-button" href={`/marketplace/${provider.key}/connect`}>
					Reconnect {provider.label}
				</a>
			</p>
		);
	}

	const busy = phase === 'pending';

	return (
		<p className="mp-fineprint">
			{phase !== 'confirming' ? (
				<button type="button" className="mp-link-button" onClick={() => setPhase('confirming')} disabled={busy}>
					{busy ? 'Disconnecting…' : `Disconnect ${provider.label}`}
				</button>
			) : (
				<>
					Uplyft will stop accessing your {provider.label} data.{' '}
					<button type="button" className="mp-link-button mp-link-button--danger" onClick={handleDisconnect} disabled={busy} autoFocus>
						Yes, disconnect
					</button>
					{' · '}
					<button type="button" className="mp-link-button" onClick={() => setPhase('idle')} disabled={busy}>
						Cancel
					</button>
				</>
			)}

			{phase === 'error' && <><br />{error}</>}
		</p>
	);
}
